import React from 'react';
import {BsLinkedin, BsGithub } from 'react-icons/bs';
const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://github.com/ronijaat" target="_blank"><BsGithub /></a>
      
    </div>
    <div>
    <a href="https://www.linkedin.com/in/raunak-baliyan-18448b201/" target="_blank"><BsLinkedin /></a>
    </div>
  </div>
);

export default SocialMedia;